import { useFluent } from "@fluentui/react-components";
import { useEffect } from "react";
export function useEventListener(source, eventName, handler, options) {
    const watchCurrent = options?.current ?? true;
    const watchPrimary = options?.primary ?? true;
    const { targetDocument: currentDocument } = useFluent();
    const currentSource = !watchCurrent ? null : source === "window" ? currentDocument?.defaultView : currentDocument;
    const primarySource = !watchPrimary ? null : source === "window" ? window : document;
    for (const eventSource of [currentSource, primarySource]) {
        useEffect(() => {
            if (eventSource && handler) {
                eventSource.addEventListener(eventName, handler);
                return () => {
                    eventSource.removeEventListener(eventName, handler);
                };
            }
            return undefined;
        }, [eventSource, eventName, handler]);
    }
}
//# sourceMappingURL=eventHooks.js.map